import * as types from '../../Types';
import {
  readRecord,
  storeRecord,
  deleteRecord,
  clearAll
} from '../../../Services/LocalStorageService';
import { LS_KEY_AUTH_DATA } from '../../../constant/constants';

const LSKEY = LS_KEY_AUTH_DATA;

export const authDataFromLS = () => {
  return readRecord(LSKEY) || {};
};

// Define a clean initial state
export const getCleanState = () => ({
  authData: authDataFromLS(),
  loading: null,
  forceLogout: null,
  error: ''
});

const initialState = getCleanState();

const RewardReducer = (state = initialState, action) => {
  let result;
  switch (action.type) {
    case types.LOGIN:
      return {
        ...state,
        authData: {},
        loading: true,
        forceLogout: null,
        error: ''
      };
    case types.DESTROY_AUTH_SESSION:
      return getCleanState();

    case types.LOGIN_SUCCESS: {
      result = action.result || {};
      // Ensure provider information is included in stored auth data
      const authDataToStore = {
        ...result,
        provider: action.payload?.authData?.provider || result.provider
      };
      storeRecord(LSKEY, authDataToStore);
      return {
        ...state,
        authData: authDataToStore,
        loading: false,
        forceLogout: null,
        error: ''
      };
    }

    case types.LOGIN_FAILURE: {
      deleteRecord(LSKEY);
      return {
        ...state,
        loading: false,
        forceLogout: null,
        error: action.error.message
      };
    }

    case types.CLEAR_AUTH_DATA: {
      clearAll();
      return {
        ...state,
        authData: {},
        loading: null,
        forceLogout: true,
        error: ''
      };
    }

    default:
      return state;
  }
};

export default RewardReducer;
